import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Header, Subheader, Detail, NextButton, ButtonsContainer } from '../../../styles';

import { ConfirmEmailValues } from '..';

import { Container, ResultImage } from '../styles';

interface Props {
  confirmEmail: ConfirmEmailValues | null;
  onHelp: () => void;
}

const ConfirmEmailNotFound = ({ confirmEmail, onHelp }: Props) => {
  const { t } = useStoreTranslation();

  if (!confirmEmail) return null;

  return (
    <Container>
      <ResultImage src="/corporate/images/warning-circle.svg" />

      <Header black>{t('login.confirmEmail.notFound.title')}</Header>
      <Subheader>{confirmEmail.email}</Subheader>
      <Detail>{t('login.confirmEmail.notFound.detail')}</Detail>

      <ButtonsContainer center>
        <NextButton onClick={onHelp}>{t('login.confirmEmail.notFound.help')}</NextButton>
      </ButtonsContainer>
    </Container>
  );
};

export default ConfirmEmailNotFound;
